// Helper: Determine the currently authenticated customer ID (Recharge)
export const getCurrentUserId = () => {
  try {
    const sessionStr = localStorage.getItem('rechargeSession');
    if (!sessionStr) return '';

    const session = JSON.parse(sessionStr);
    return String(
      session.customer_id ||
        session.customerId ||
        session.customer?.id ||
        ''
    );
  } catch {
    return '';
  }
};